import i18n from "i18next";
import * as es from "./locales/es.json";

const resource = {
  es: {
    translation: es
  }
};

i18n.init({
  debug: false,
  lng: 'es',
  resources: resource
});

export default i18n;
